export default "__VITE_ASSET__3c9ef4a3__"